import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCalendarDefault = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.33333 1.33325V2.75177M5.33333 3.99992V2.75177M10.6667 1.33325V2.75177M10.6667 3.99992V2.75177M5.33333 2.75177C5.00146 2.79683 4.72359 2.86572 4.46927 2.97107C3.48915 3.37704 2.71046 4.15574 2.30448 5.13585C2.13555 5.54368 2.06035 6.01208 2.02687 6.66658C2 7.19179 2 7.83684 2 8.66658C2 10.5304 2 11.4622 2.30448 12.1973C2.71046 13.1774 3.48915 13.9561 4.46927 14.3621C5.20435 14.6666 6.13623 14.6666 8 14.6666C9.86377 14.6666 10.7956 14.6666 11.5307 14.3621C12.5108 13.9561 13.2895 13.1774 13.6955 12.1973C14 11.4622 14 10.5304 14 8.66658C14 7.83684 14 7.19179 13.9731 6.66658M13.9731 6.66658C13.9397 6.01208 13.8644 5.54368 13.6955 5.13585C13.2895 4.15574 12.5108 3.37704 11.5307 2.97107C11.2764 2.86572 10.9985 2.79683 10.6667 2.75177M13.9731 6.66658H2.02687M5.33333 2.75177C5.96071 2.66659 6.78105 2.66659 8 2.66659C9.21895 2.66659 10.0393 2.66659 10.6667 2.75177",
		stroke: "#111827",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgCalendarDefault);
export default ForwardRef;
